import type { SnapshotId } from '@ipfabric/utils';
import type { DeviceViewEntity } from '../deviceViewTypes';

export const getRequestSnapshotId = (
  deviceViewEntity: DeviceViewEntity,
  snapshotId: SnapshotId | null,
  snapshotToCompareId?: SnapshotId | null,
): SnapshotId | null => {
  if (
    snapshotToCompareId &&
    (deviceViewEntity.deviceViewElement === 'node' ||
      deviceViewEntity.deviceViewElement === 'edge') &&
    deviceViewEntity.compareMode === 'added'
  ) {
    return snapshotToCompareId;
  }
  return snapshotId;
};
